import { Quote } from 'lucide-react';

interface Testimonial {
  name: string;
  content: string;
}

interface TestimonialsSectionProps {
  testimonials: Testimonial[];
}

const TestimonialsSection = ({ testimonials }: TestimonialsSectionProps) => {
  return (
    <section className="py-16">
      {/* Header */}
      <div className="text-center mb-10">
        <h2 className="text-2xl lg:text-3xl font-bold text-foreground mb-2">
          Stories from Fellow Thrivers
        </h2>
        <p className="text-muted-foreground">
          Real experiences from people living their best lives at home
        </p>
      </div>
      
      {/* Testimonials Grid */}
      <div className="grid md:grid-cols-3 gap-6">
        {testimonials.map((testimonial, index) => (
          <div 
            key={index} 
            className="bg-background border border-border/50 rounded-xl p-6 hover:border-primary/20 hover:shadow-sm transition-all"
          >
            <Quote className="w-8 h-8 text-primary/20 mb-3" />
            <p className="text-muted-foreground mb-4 leading-relaxed text-sm">
              {testimonial.content}
            </p>
            <p className="font-medium text-primary text-sm">— {testimonial.name}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TestimonialsSection;
